import React, { useEffect, useState } from "react";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { message } from "../../redux/actions/toastActions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import Loader from "../../components/common/Loader";
import { FiArrowLeft } from "react-icons/fi";
import { toast } from "sonner";
import { isRole, isRoleType } from "../../redux/selectors/authSelector";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";
import axios from "axios";

const AddSchool = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    school_name: "",
    password: "",
    email: "",
    mobile: "",
    subdomain: "",
    credit: "",
    isAgreeTC: false,
    logo: null,
    country_code: "",
    banner_image: null,
  });
  const [refresh, setRefresh] = useState(false);
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const [countries, setCountries] = useState([]);
  const [countryOpen, setCountryOpen] = useState(false);
  const ALLOWED_COUNTRY_CODES = ["ke", "ug"];
  const [selectedCountry, setSelectedCountry] = useState("KE");
  const flagsContext = require.context(
    "../../assets/flags",
    false,
    /\.(png|jpe?g|svg)$/,
  );

  const getFlagImage = (code) => {
    try {
      return flagsContext(`./${code.toLowerCase()}.png`);
    } catch {
      return null;
    }
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await axios.get(HttpService.school_country_show);
        if (res.status === 200 && Array.isArray(res.data.data)) {
          const activeCountries = res.data.data
            .filter(
              (c) =>
                c.isActive &&
                ALLOWED_COUNTRY_CODES.includes(c.code.toLowerCase()),
            )
            .sort((a, b) => (a.code.toLowerCase() === "ke" ? -1 : 1));

          setCountries(activeCountries);
        }
      } catch (err) {
        console.error("Error fetching countries:", err);
      }
    };

    fetchCountries();
  }, []);

  const validateForm = () => {
    let newErrors = {};

    if (!formData.first_name.trim()) {
      newErrors.first_name = "First name is required";
    }

    if (!formData.last_name.trim()) {
      newErrors.last_name = "Last name is required";
    }

    // if (!formData.username.trim()) {
    //   newErrors.username = "Username is required";
    // }
    if (!formData.username?.trim()) {
      newErrors.username = "Username is required";
    } else if (!/^(?=.*[A-Za-z])[A-Za-z0-9]+$/.test(formData.username)) {
      newErrors.username =
        "Username must contain at letter and can include numbers.";
    }

    if (!formData.school_name.trim()) {
      newErrors.school_name = "School name is required";
    }

    const passwordRegex =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$!%&*])[A-Za-z\d@#$!%&*]{8,12}$/;
    if (location.state?.type !== "edit" && !formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password && !passwordRegex.test(formData.password)) {
      newErrors.password =
        "Password must be 8–12 characters, include uppercase, lowercase, number, and special character (@#$!%&*)";
    }

    const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    if (!formData.email?.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Mobile number must be 10 digits";
    }

    if (!formData.isAgreeTC) {
      newErrors.isAgreeTC = "You must agree to the terms & conditions";
    }
    if (!formData.logo) {
      newErrors.logo = "School logo is required";
    } else {
      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/webp",
        "image/jpg",
      ];
      if (
        typeof formData.logo !== "string" &&
        !allowedTypes.includes(formData.logo.type)
      ) {
        newErrors.logo = "Only JPG, JPEG, PNG, or WEBP formats are allowed";
      }
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (formData.logo.size > maxSize) {
        newErrors.logo = "Logo size must be less than or equal to 10MB";
      }
    }

    if (!formData.banner_image) {
      newErrors.banner_image = "School banner image is required";
    } else {
      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/webp",
        "image/jpg",
      ];
      if (
        typeof formData.banner_image !== "string" &&
        !allowedTypes.includes(formData.banner_image.type)
      ) {
        newErrors.banner_image =
          "Only JPG, JPEG, PNG, or WEBP formats are allowed";
      }
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (formData.banner_image.size > maxSize) {
        newErrors.banner_image =
          "Banner image size must be less than or equal to 10MB";
      }
    }

    const subdomainRegex = /^(?=.*[a-z])[a-z0-9]+$/;
    if (!formData.subdomain.trim()) {
      newErrors.subdomain = "Subdomain is required";
    } else if (!subdomainRegex.test(formData.subdomain)) {
      newErrors.subdomain =
        "Subdomain must contain only lowercase letters and numbers, and cannot be only numbers";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];

    if (file.size > 5 * 1024 * 1024) {
      toast.warning("The logo cannot be larger than 5MB");
      return;
    }

    setFormData({
      ...formData,
      logo: file,
    });
  };

  const handleBannerChange = (e) => {
    const file = e.target.files[0];

    if (file.size > 5 * 1024 * 1024) {
      toast.warning("The banner cannot be larger than 5MB");
      return;
    }

    setFormData({
      ...formData,
      banner_image: file,
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }

    if (
      (name === "first_name" || name === "last_name") &&
      !/^[A-Za-z ]*$/.test(value)
    ) {
      return; // Prevent updating the form data if non-alphabetic character is entered
    }

    if (name === "mobile" && !/^\d*$/.test(value)) {
      return;
    }

    if (name === "credit" && !/^\d*$/.test(value)) {
      return;
    }

    // Convert email to lowercase automatically
    if (name === "email") {
      setFormData({
        ...formData,
        [name]: value.toLowerCase(),
      });
      return;
    }

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoader(true);

    const form = new FormData();
    form.append("first_name", formData.first_name);
    form.append("last_name", formData.last_name);
    form.append("username", formData.username);
    form.append("school_name", formData.school_name);
    form.append("password", formData.password);
    form.append("subdomain", formData.subdomain);
    form.append("email", formData.email);
    form.append("mobile_number", formData.mobile);
    form.append("isAgreeTC", formData.isAgreeTC);
    form.append("country_code", selectedCountry);
    if (formData.credit !== "" && formData.credit !== undefined) {
      form.append("credit", formData.credit);
    }
    if (params.id) {
      form.append("id", params.id);
    }
    if (formData.logo) {
      form.append("logo", formData.logo);
    }
    if (formData.banner_image) {
      form.append("banner_image", formData.banner_image);
    }

    Postdata(HttpService.admin_school_add, form).then((res) => {
      console.log("ADMIN SCHOOL ADD RESPONSE 👉", res);
      if (res.status === 200) {
        toast.success(res.message || "School saved successfully!");
        const schoolId = res.data.school._id;
        const countryCode = formData.country_code;
        localStorage.setItem("activeSchoolId", schoolId);
        localStorage.setItem("activeCountryCode", countryCode);

        if (role === "schooladmin") {
          navigate("admin-school");
        } else {
          navigate("navigation-dashboard", {
            state: { mainTab: "Management", countryCode: countryCode },
          });
        }
      } else {
        toast.error(res.message || "Something went wrong!");
      }
    }).catch((err) => {
      const errorMsg = err?.response?.data?.message || err?.message || "Something went wrong!";
      toast.error(errorMsg);
    }).finally(() => {
      setLoader(false);
    });
    console.log("Submitted as FormData:", formData);
  };
  const fetchData = () => {
    setLoader(true);
    Postdata(HttpService.admin_school_show, { id: params.id }).then((res) => {
      if (res.status == 200) {
        setFormData({
          first_name: res.data.first_name,
          last_name: res.data.last_name,
          username: res.data.username,
          school_name: res.data.name,
          email: res.data.email,
          subdomain: res.data.subdomain,
          mobile: res.data.mobile_number,
          credit: res.data.credit ?? "",
          isAgreeTC: res.data.isAgreeTC,
          country_code: res.data.country_code || "KE",
          logo: res.data.logo,
          banner_image: res.data.banner_image,
        });
        setSelectedCountry(res.data.country_code);
      } else {
        dispatch(message(res.message));
      }
      setLoader(false);
    });
  };

  useEffect(() => {
    if (params.id) {
      fetchData();
    }
  }, [refresh]);

  if (loader) {
    return <Loader isClass="loader_fullscreen" />;
  }
  return (
    <div className="p-6 space-y-6 pr-0">
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="w-full  bg-white  rounded-xl p-6">
          <div
            className="flex items-center mb-4 cursor-pointer"
            onClick={() => navigate("admin-school")}
          >
            <FiArrowLeft className="text-2xl font-bold mb-6 text-gray-800" />
            <h2 className="text-2xl font-bold mb-6 text-gray-800">
              School Form
            </h2>
          </div>

          <form
            onSubmit={handleSubmit}
            autoComplete="off"
            noValidate
            className="space-y-5"
          >
            {/* First & Last Name */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  First Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter first name"
                />
                {errors.first_name && (
                  <p className="text-red-500 text-sm">{errors.first_name}</p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Last Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter last name"
                />
                {errors.last_name && (
                  <p className="text-red-500 text-sm">{errors.last_name}</p>
                )}
              </div>
            </div>

            {/* School Logo */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                School Logo<span className="text-red-500">*</span>
              </label>
              <input
                type="file"
                accept="image/jpeg,image/png,image/webp"
                onChange={handleLogoChange}
                className="mt-1 w-full border border-gray-300 rounded-lg p-2"
              />
              {errors.logo && (
                <p className="text-red-500 text-sm">{errors.logo}</p>
              )}
              {formData.logo && (
                <div className="mt-2">
                  <img
                    src={
                      typeof formData.logo === "string"
                        ? formData.logo
                        : URL.createObjectURL(formData.logo)
                    }
                    alt="Preview"
                    className="w-24 h-24 object-cover rounded-lg border"
                  />
                </div>
              )}
            </div>

            {/* Banner Upload */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                School Banner <span className="text-red-500">*</span>
              </label>
              <input
                type="file"
                accept="image/jpeg,image/png,image/webp"
                onChange={handleBannerChange}
                className="mt-1 w-full border border-gray-300 rounded-lg p-2"
              />
              {errors.banner_image && (
                <p className="text-red-500 text-sm">{errors.banner_image}</p>
              )}
              {formData.banner_image && (
                <div className="mt-2">
                  <img
                    src={
                      typeof formData.banner_image === "string"
                        ? formData.banner_image
                        : URL.createObjectURL(formData.banner_image)
                    }
                    alt="Banner Preview"
                    className="w-full max-h-48 object-cover rounded-lg border"
                  />
                </div>
              )}
            </div>

            {/* Username */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Username <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                placeholder="Enter username"
              />
              {errors.username && (
                <p className="text-red-500 text-sm">{errors.username}</p>
              )}
            </div>

            {/* School Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                School Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="school_name"
                value={formData.school_name}
                onChange={handleChange}
                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                placeholder="Enter school name"
              />
              {errors.school_name && (
                <p className="text-red-500 text-sm">{errors.school_name}</p>
              )}
            </div>

            {/* Password */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Password <span className="text-red-500">*</span>
              </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                placeholder="Enter password"
              />
              {errors.password && (
                <p className="text-red-500 text-sm">{errors.password}</p>
              )}
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Email <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                placeholder="Enter email"
              />
              {errors.email && (
                <p className="text-red-500 text-sm">{errors.email}</p>
              )}
            </div>

            {/* Mobile */}
            {/* <div>
              <label className="block text-sm font-medium text-gray-700">
                Mobile <span className="text-red-500">*</span>
              </label>
              <input
                type="tel"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                maxLength={10}
                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                placeholder="Enter mobile number"
              />
              {errors.mobile && (
                <p className="text-red-500 text-sm">{errors.mobile}</p>
              )}
            </div> */}
            <div className="relative">
              <label className="block text-sm font-medium text-gray-700">
                Mobile <span className="text-red-500">*</span>
              </label>

              <div className="flex">
                {/* FLAG DROPDOWN */}
                <div
                  className="flex items-center p-2 mt-1  border border-gray-300 rounded-l-lg cursor-pointer bg-gray-100"
                  onClick={() => setCountryOpen((prev) => !prev)}
                >
                  <img
                    src={getFlagImage(selectedCountry)}
                    alt="flag"
                    className="w-5 h-3"
                  />
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    className="ml-1"
                  >
                    <path
                      d="M3 4.5L6 7.5L9 4.5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    />
                  </svg>
                </div>

                {/* MOBILE INPUT */}
                <input
                  type="tel"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  maxLength={10}
                  className="mt-1 w-full border border-gray-300 border-l-0 rounded-r-lg p-2 focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter mobile number"
                />
              </div>

              {/* DROPDOWN MENU */}
              {countryOpen && (
                <div className="absolute top-full left-0 z-50 bg-white border rounded shadow-md w-44 max-h-60 overflow-auto">
                  {countries.map((country) => (
                    <div
                      key={country._id}
                      className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-100"
                      onClick={() => {
                        setSelectedCountry(country.code);
                        setFormData({
                          ...formData,
                          country_code: country.code,
                        });
                        setCountryOpen(false);
                      }}
                    >
                      <img
                        src={getFlagImage(country.code)}
                        alt={country.name}
                        className="w-5 h-3"
                      />
                      <span className="text-sm">{country.name}</span>
                    </div>
                  ))}
                </div>
              )}

              {errors.mobile && (
                <p className="text-red-500 text-sm mt-1">{errors.mobile}</p>
              )}
            </div>

            {/* SubDomain */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Sub Domain <span className="text-red-500">*</span>
              </label>
              <input
                type="tel"
                name="subdomain"
                value={formData.subdomain}
                onChange={handleChange}
                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                placeholder="Enter Sub Domain"
              />
              {errors.subdomain && (
                <p className="text-red-500 text-sm">{errors.subdomain}</p>
              )}
            </div>

            {/* SMS Credits */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                SMS Credits
              </label>
              <input
                type="number"
                name="credit"
                value={formData.credit}
                onChange={handleChange}
                min={0}
                className="mt-1 w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                placeholder="Enter SMS credits"
              />
            </div>

            {/* Terms & Conditions */}
            <div className="flex items-center">
              <input
                id="isAgreeTC"
                name="isAgreeTC"
                type="checkbox"
                checked={formData.isAgreeTC}
                onChange={handleChange}
                className="h-4 w-4 text-blue-600 border-gray-300 rounded"
              />
              <label
                htmlFor="isAgreeTC"
                className="ml-2 block text-sm text-gray-700"
              >
                I agree to the Terms & Conditions{" "}
                <span className="text-red-500">*</span>
              </label>
            </div>
            {errors.isAgreeTC && (
              <p className="text-red-500 text-sm">{errors.isAgreeTC}</p>
            )}

            {/* Submit Button */}
            <div className="w-full flex justify-center gap-3 mb-2 mt-4">
              <button
                type="submit"
                className="button-field-primary"
                style={{ width: "30%" }}
                disabled={loader}
              >
                {loader ? "Please wait..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddSchool;
